// Blog filter
(function () {
  var filterList    = document.querySelector('.main-blog__filter-list');
  var filterItems   = Array.from(document.querySelectorAll('.main-blog__filter__item'));
  var filterBtn     = document.querySelector('.main-blog__filter__button');
  var filterCurrent = document.querySelector('.main-blog__filter-list__current');
  var pathname      = window.location.pathname;

  if (filterList) {
    filterList.addEventListener('click', function () {
      filterList.classList.toggle('active');
    });
  }

  filterItems.forEach(function (item) {
    item.addEventListener('click', function () {
      filterItems.forEach(function (i) { i.classList.remove('active'); });
      item.classList.add('active');
      var span = filterCurrent && filterCurrent.querySelector('span');
      if (span) span.textContent = item.textContent;
      if (filterBtn) filterBtn.setAttribute('href', item.dataset.href);
    });
  });

  if (pathname) {
    filterItems.forEach(function (item) {
      if (pathname.includes(item.dataset.tagHandle)) {
        var span = filterCurrent && filterCurrent.querySelector('span');
        if (span) span.textContent = item.textContent;
      }
    });
  }
})();

// Blog sort
(function () {
  var sortBars = Array.from(document.querySelectorAll('[data-sort-bar]'));
  if (!sortBars.length) return;

  function sort(param) {
    var items = Array.from(document.querySelectorAll('[data-sort-item]'));
    var clean = function (str) { return str ? str.replace(/th,|st,|nd,|rd,/g, ',') : null; };

    items.slice().sort(function (a, b) {
      var aTitle = a.querySelector('.heading') && a.querySelector('.heading').innerHTML;
      var bTitle = b.querySelector('.heading') && b.querySelector('.heading').innerHTML;
      var aDate  = clean(a.getAttribute('data-publish-as'));
      var bDate  = clean(b.getAttribute('data-publish-as'));

      switch (param) {
        case 'title-ascending':    return aTitle && bTitle ? aTitle.localeCompare(bTitle)  : 0;
        case 'title-descending':   return aTitle && bTitle ? -aTitle.localeCompare(bTitle) : 0;
        case 'created-ascending':  return aDate  && bDate  ? new Date(aDate) - new Date(bDate) : 0;
        case 'created-descending': return aDate  && bDate  ? new Date(bDate) - new Date(aDate) : 0;
        default: return 0;
      }
    }).forEach(function (item, idx) {
      item.style.order = idx;
    });
  }

  sortBars.forEach(function (bar) {
    var select = bar.querySelector('[data-sort-select]');
    sort('created-descending');
    if (select) {
      select.addEventListener('change', function () { sort(select.value); });
    }
  });
})();
